<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Saját Adatok</span>

    </div>
    <el-form
      v-loading="loading"
      :model="user"
      label-position="top"
    >
      <el-row :gutter="20" style="display: flex; align-items: center">
        <el-col :span="21">
          <el-form-item
            prop="email"
            label="E-mail cím"
          >
            <el-input
              v-model="user.email"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-button
            type="primary"
            @click="$router.replace('/my-profile/update-password')"
            style="width: 100%"
          >
            Jelszó változtatás
          </el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="last_name"
            label="Vezetéknév"
          >
            <el-input
              v-model="user.last_name"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="last_name"
            label="Utónév"
          >
            <el-input
              v-model="user.first_name"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
  export default {
    data() {
      return {
        user: {},
        loading: false,
      };
    },
    async mounted() {
      this.user = this.$store.getters['auth/user'];
      if (!this.user) {
        this.loading = true;
        await this.$store.dispatch('auth/fetchUser');
        this.user = this.$store.getters['auth/user'];
        this.loading = false;
      }
    }
  };
</script>
